<template>
  <div :class="['ms-form', 'ms-form--narrow', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInput
          label="Цена"
          :required="true"
          type="number"
          :value="this.formData.contractor_work_set_price"
          @change_input="(value) => onChange('contractor_work_set_price', value)"
        />
        <!-- период «от – до» — парой в одной строке -->
        <div class="ms-form-grid">
          <CustomDate
            :required="true"
            :minWidthMode="true"
            placeholder="Дата от"
            :value="this.formData.date_begin || ''"
            @change_date="(value) => onChange('date_begin', value)"
          />
          <CustomDate
            :required="true"
            :minWidthMode="true"
            placeholder="Дата до"
            :value="this.formData.date_end || ''"
            @change_date="(value) => onChange('date_end', value)"
          />
        </div>
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomDate from "@/components/form/CustomDate";
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "add-workset-price",
  components: {CustomDate, CustomInput, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        date_begin: this.data?.body?.date_begin || '',
        date_end: this.data?.body?.date_end || '',
        contractor_work_set_price: this.data?.body?.contractor_work_set_price || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
}
</script>
